var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    fill: "#FF7916"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 8.125C17 7.50625 16.505 7 15.9 7H7.1C6.495 7 6 7.50625 6 8.125M17 8.125V14.875C17 15.4938 16.505 16 15.9 16H7.1C6.495 16 6 15.4938 6 14.875V8.125M17 8.125L11.5 12.0625L6 8.125",
    stroke: "white",
    strokeWidth: 1.575,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.7d405324188b3422061a06e51ad2fd03.svg";
export { ForwardRef as ReactComponent };